import { PopoverOrigin } from "@mui/material";
import { SearchResultGroupInterface } from "@iventis/search/interface/search-result-interface";
import { MapSearchResultType } from "@iventis/search/types/types";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";

export enum MapInterfaceStyle {
    COMPRESSED = "Compressed",
    SPACIOUS = "Spacious",
}

export enum PopoverComponents {
    MAP_SETTINGS = "MAP_SETTINGS",
    VIEW_BY = "VIEW_BY",
    SITEMAP_SELECTOR = "SITEMAP_SELECTOR",
    LEVEL_SELECTOR = "LEVEL_SELECTOR",
    SEARCH = "SEARCH",
}

export type FullScreenSelector = PopoverComponents.LEVEL_SELECTOR | PopoverComponents.SITEMAP_SELECTOR | PopoverComponents.SEARCH;

export interface PopoverPayload {
    component: PopoverComponents;
    props?: { searchResultGroups?: SearchResultGroupInterface<MapSearchResultType>[]; onClose: () => void };
    nodeId: string;
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
    translateY?: string;
}

export interface SidebarState {
    mapInterfaceStyle: MapInterfaceStyle;
    popoverOpen: boolean;
    popover: PopoverPayload;
    importLayer: boolean;
    parentFolderId: string;
    fullScreenSelector: FullScreenSelector;
    showImportLayer: boolean;
    content: SidebarContent;
    editingNodeName: boolean;
    modalLayer: { id?: string; anchor?: "sidebar" | "node"; skipTemplateSelection?: boolean };
    attributeId: string;
    attributeLayerId: string;
    previousLibraryId: string;
    layersUndertakingPreviewSnapshots: MapLayer[];
    /** Whether the relay timetable is shown in the resizable panel at the bottom of the map. Only relevant for maps containing streams */
    relayTimetableOpen: boolean;
    /** Whether the open relay timetable is listening for a stage to be excluded or put back, which it is not while it loads */
    relayTimetableStageExclusionReady: boolean;
    /** The stages whose exclusion from the relay timetable is saving */
    relayTimetableStageExclusionSavingIds: string[];
}

export enum SidebarContent {
    LAYERS = "layers",
    DATA_TABLE = "data_table",
    BACKGROUND_MAP = "background_map",
    CHANGE_LOG = "change_log",
}

/** modalLayerId in sidebar slice is set to this when a new layer is being created */
export const MODAL_NEW_LAYER_ID = "MODAL_NEW_LAYER";
